enum ETopic {
	discord = 'discord',
	github = 'github',
	quests = 'quests',
	campaigns = 'campaigns',
	faucet = 'faucet'
}

enum EDiscordEvent {
	permissionsAdded = 'permissionsAdded',
	permissionsRemoved = 'permissionsRemoved',
	usernameUpdated = 'usernameUpdated'
}

enum EGithubEvent {
	appInstalled = 'appInstalled',
	appRemoved = 'appRemoved',
	usernameUpdated = 'usernameUpdated-', // The '-' is added to the end of the event name to avoid a conflict with the 'usernameUpdated' event from the 'discord' topic.
	repositoryChanged = 'repositoryChanged'
}

enum EQuestsEvent {
	questStarted = 'questStarted',
	questFinished = 'questFinished',
	offChainVerificationStarted = 'offChainVerificationStarted',
	offChainVerificationFinished = 'offChainVerificationFinished',
	offChainVerificationFailed = 'offChainVerificationFailed'
}

enum ECampaignsEvent {
	campaignStarted = 'campaignStarted',
	campaignFinished = 'campaignFinished'
}

enum EFaucetEvent {
	sent = 'sent',
	processed = 'processed',
	failed = 'failed'
}

export { ETopic, EDiscordEvent, EGithubEvent, EQuestsEvent, ECampaignsEvent, EFaucetEvent };
